export default function ChinhSachDoiTra() {
  return (
    <div className="bg-white text-gray-800 py-12 px-4 md:px-8 lg:px-16 max-w-6xl mx-auto mt-16">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-pink-600 uppercase">
          Chính Sách Đổi Trả
        </h1>
        <p className="mt-4 text-gray-600 text-base md:text-lg">
          Với mong muốn mang đến sự hài lòng tuyệt đối, PT2000 hỗ trợ đổi trả sản phẩm trong thời gian quy định nếu đáp ứng đủ điều kiện.
        </p>
      </div>

      <div className="space-y-8 text-gray-700 leading-relaxed">
        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">1. Thời gian & phạm vi áp dụng</h2>
          <ul className="list-disc pl-5">
            <li>Thời gian đổi/trả: Trong vòng <strong>03 ngày</strong> kể từ ngày nhận hàng.</li>
            <li>Áp dụng cho tất cả đơn hàng mua tại website chính thức của PT2000 hoặc các kênh online trực thuộc.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">2. Điều kiện đổi/trả</h2>
          <ul className="list-disc pl-5">
            <li>Sản phẩm chưa qua sử dụng, không giặt, không hư hại, còn nguyên tag & bao bì.</li>
            <li>Hóa đơn mua hàng hoặc mã đơn hàng còn đầy đủ.</li>
            <li>Không áp dụng đổi/trả cho các sản phẩm giảm giá trên 30% hoặc hàng thuộc chương trình "Xả kho", "Flash sale".</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">3. Trường hợp được đổi/trả</h2>
          <ul className="list-disc pl-5">
            <li>Sản phẩm bị lỗi kỹ thuật (rách, bung chỉ, dính vết bẩn khi chưa sử dụng).</li>
            <li>Sản phẩm không đúng mẫu mã, kích cỡ hoặc màu sắc như đặt hàng.</li>
            <li>Khách hàng đổi size (nếu còn hàng trong kho).</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">4. Quy trình đổi/trả</h2>
          <ol className="list-decimal pl-5 space-y-1">
            <li>Liên hệ bộ phận CSKH qua hotline <strong>0784 992 000</strong> hoặc inbox fanpage PT2000.</li>
            <li>Cung cấp mã đơn hàng, lý do đổi/trả, hình ảnh sản phẩm.</li>
            <li>Gửi sản phẩm về trung tâm xử lý đổi trả của PT2000 theo hướng dẫn.</li>
            <li>Sau khi kiểm tra đủ điều kiện, sản phẩm mới sẽ được gửi lại (đối với đổi) hoặc hoàn tiền theo hình thức ban đầu (đối với trả).</li>
          </ol>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">5. Chi phí đổi/trả</h2>
          <ul className="list-disc pl-5">
            <li>Miễn phí đổi trả nếu lỗi từ nhà sản xuất hoặc do vận chuyển.</li>
            <li>Khách hàng chịu phí vận chuyển 1 chiều nếu đổi do không vừa size, không ưng màu hoặc muốn đổi mẫu.</li>
            <li>Không hoàn phí vận chuyển ban đầu.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">6. Lưu ý quan trọng</h2>
          <ul className="list-disc pl-5">
            <li>Không hỗ trợ đổi trả với sản phẩm đã qua sử dụng hoặc không đủ điều kiện.</li>
            <li>Thời gian xử lý đổi/trả: 3–7 ngày làm việc sau khi PT2000 nhận được sản phẩm.</li>
            <li>Mỗi đơn hàng chỉ hỗ trợ đổi/trả 01 lần duy nhất.</li>
          </ul>
        </div>
      </div>

      <div className="mt-12 text-center border-t pt-6">
        <p className="text-gray-700">
          Mọi thắc mắc vui lòng liên hệ bộ phận hỗ trợ khách hàng qua hotline&nbsp;
          <a href="tel:0784992000" className="text-pink-600 underline font-medium">0784 992 000</a>
        </p>
      </div>
    </div>
  );
}
